import axios from 'axios';

import { Option } from '@gn-audio/jss-core/common/models';

import getConfig from '../temp/config';

export const getCustomizerConfig = async (
  productDataSourceID: string,
  language?: string
): Promise<CustomizerConfig> => {
  const config = getConfig();
  const url = `${config.sitecoreApiHost}/${
    language ?? 'en-us'
  }/public-api/customizer/hero-customizer-v3/${productDataSourceID}`;
  const res = await axios.get<CustomizerConfig>(url);
  return res.data;
};

export interface CustomizerConfig {
  familyId: number;
  groupIds: unknown[];
  keepGroupSortOrder: boolean;
  shopRibbon: string;
  disclaimer: string;
  footerMessage: string;
  hideUSPOnMobile: boolean;
  filters: Filter[];
  showColorsAsDots: boolean;
  applePayV2Enabled: boolean;
  googlePayEnabled: boolean;
  lifestyleImages: unknown[];
  features: Feature[];
  showAccessories: boolean;
  accessoryTypes: AccessoryType[];
}

export interface Filter {
  name: string;
  title: string;
  summary: string;
  alwaysVisibleInComparison: boolean;
  options: Option[];
}

interface Feature {
  text: string;
  header: string;
}

interface AccessoryType {
  title: string;
  value: string;
  key: string;
}
